var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3507 17.3507C16.3682 18.3333 14.7868 18.3333 11.6241 18.3333C8.46133 18.3333 6.87997 18.3333 5.89742 17.3507C5.34963 16.803 5.10725 16.0691 5 14.9788M14.9788 5C16.0691 5.10725 16.803 5.34963 17.3507 5.89742C18.3333 6.87997 18.3333 8.46133 18.3333 11.6241C18.3333 12.8183 18.3333 13.7872 18.2804 14.5833",
    stroke: "#BBBBBB",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.024 14.0236C13.0477 15 11.4763 15 8.33366 15C5.19096 15 3.61962 15 2.6433 14.0236C1.66699 13.0474 1.66699 11.476 1.66699 8.33329C1.66699 5.19059 1.66699 3.61925 2.6433 2.64293M5.41699 1.71763C6.20363 1.66663 7.15885 1.66663 8.33366 1.66663C11.4763 1.66663 13.0477 1.66663 14.024 2.64293C15.0003 3.61925 15.0003 5.19059 15.0003 8.33329C15.0003 9.50813 15.0003 10.4633 14.9493 11.25",
    stroke: "#BBBBBB",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 14.1667C5.68166 12.1968 7.26954 10.3472 9.16699 9.16671M15.0003 9.62029C13.9572 8.81554 12.9893 8.42054 12.0837 8.33337",
    stroke: "#BBBBBB",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 1.66663L18.3337 18.3333",
    stroke: "#BBBBBB",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImages);
export default __webpack_public_path__ + "static/media/no_images.c0b456cc58f05c68317ad1d2df0b7aeb.svg";
export { ForwardRef as ReactComponent };